import React from "react";
import { MediaFeature } from "./MediaFeature";
import EditorVideoMP4 from "../../../images/editor.mp4";
import EditorVideo from "../../../images/editor.webm";

export const CardEditorFeature: React.FC<{ showCaption?: boolean }> = ({
  showCaption = true,
}) => {
  return (
    <MediaFeature
      header={
        <>
          <span>Powerful card customization</span>
          <br />
          <div className="flex flex-row">
            <span className="text-purple-600">
              that experts and beginners love
            </span>
          </div>
        </>
      }
      body={
        <>
          Creating Zorbi cards is free, easy, and delightful. Other apps make
          you pay for basic features like changing the colour of text, we'll
          never do that.
          <br />
          <br />
          <ul className="p-0 m-0 leading-6 border-0 border-gray-300">
            <li className="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
              <span className="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full">
                <span className="text-sm font-bold">✓</span>
              </span>{" "}
              Images, equations, audio, and more
            </li>
            <li className="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
              <span className="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full">
                <span className="text-sm font-bold">✓</span>
              </span>{" "}
              Organize cards into structured topics
            </li>
            <li className="box-border relative py-1 pl-0 text-left text-gray-500 border-solid">
              <span className="inline-flex items-center justify-center w-6 h-6 mr-2 text-white bg-purple-300 rounded-full">
                <span className="text-sm font-bold">✓</span>
              </span>{" "}
              Cloze deletions (fill-in-the-blanks flashcards)
            </li>
          </ul>
        </>
      }
      media={
        <video
          autoPlay
          playsInline
          muted
          loop
          preload="auto"
          className=" xl:h-128 lg:h-80 rounded-DEFAULT"
        >
          <source src={EditorVideo} type="video/webm" />
          <source src={EditorVideoMP4} type="video/mp4" />
        </video>
      }
      mediaSide={"left"}
    />
  );
};
